import type { BoxProps } from '@chakra-ui/react';
import { Box, Flex } from '@chakra-ui/react';
import { InfiniteLoader } from '@ui/components/InfiniteLoader';
import { useAgents } from '@ui/hooks/api/useAgents';

import { AgentCard } from './AgentCard';
import { Empty } from './Empty';
import { HardCodedCaraAgentCard } from './HardCodedCaraAgentCard';
import { Loading } from './Loading';
import { useAgentsView } from './useAgentsView';

export const AgentList = (props: BoxProps) => {
  const isGraduated = useAgentsView((s) => s.isGraduated);
  const sortBy = useAgentsView((s) => s.sortBy);
  const search = useAgentsView((s) => s.search);

  const agentsRet = useAgents({
    isGraduated,
    sortBy,
    search,
  });

  const isEmpty = agentsRet.data && !agentsRet.data.pages[0]?.length;

  return (
    <Box {...props}>
      <Flex flexDir="column" gapY="32px" gapX="20px">
        <HardCodedCaraAgentCard />
        {agentsRet.data?.pages.map((page) => {
          return page.map((agent) => {
            return (
              <AgentCard key={agent.bonding_token_address} agent={agent} />
            );
          });
        })}
        {agentsRet.isInitialLoading && <Loading />}
      </Flex>
      {isEmpty && <Empty />}
      {agentsRet.isInitialLoading ? null : (
        <InfiniteLoader
          hasMore={Boolean(agentsRet.hasNextPage)}
          onNext={async () => {
            return agentsRet.fetchNextPage();
          }}
        />
      )}
    </Box>
  );
};
